export const saveToLocalStorage = <T>(key: string, value: T) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
  }
};

export const removeFromLocalStorage = (key: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.removeItem(key);
  }
};

export const getFromLocalStorage = <T>(key: string): T | null => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const data = window.localStorage.getItem(key);
    if (data) {
      try {
        return JSON.parse(data) as T;
      } catch {
        return data as T; // Nếu không phải JSON, trả về nguyên giá trị
      }
    }
    return null;
  }
  return null;
};

export function toSlug(title: string): string {
  return title
    .toLowerCase()
    .normalize('NFD') // tách dấu tiếng Việt
    .replace(/[\u0300-\u036f]/g, '') // xóa dấu
    .replace(/[^a-z0-9\s-]/g, '') // xóa ký tự đặc biệt
    .trim()
    .replace(/\s+/g, '-') // khoảng trắng -> dấu gạch
    .replace(/-+/g, '-'); // gộp nhiều dấu gạch thành 1
}

export function toTitleCase(str: string) {
  return str
    .toLowerCase() // Chuyển tất cả thành chữ thường trước
    .split(' ') // Tách từng từ bằng khoảng trắng
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Viết hoa chữ cái đầu mỗi từ
    .join(' '); // Ghép lại thành chuỗi hoàn chỉnh
}

export function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ');
}
